


















// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Model
import { FormPosition } from '@/models/config'

// Components
import { FormCreateEditPosition } from '@/components/config'

@Component({
    name: 'ModalCreateEditPosition',
    components: {
        FormCreateEditPosition
    }
})
export default class ModalCreateEditPosition extends Vue {
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ required: true }) position!: FormPosition

    get title () {
        if (this.actionForm === 'save') {
            return 'Crear nuevo cargo'
        }
        return 'Editar cargo'
    }
}
